import axios from "axios";

const GetDepartmentList = async () => {
  return axios.get(`Department/GetDepartments`).then((response) => response);
};

const AddDepartment = async (payload) => {
  const config = {
    method: "post",
    url: `Department/AddDepartment`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const UpdateDepartment = async (payload) => {
  const config = {
    method: "post",
    url: `Department/UpdateDepartment`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const departmentService = {
  GetDepartmentList,
  AddDepartment,
  UpdateDepartment,
};

export default departmentService;
